import { getContext, invoke, getFrameId, reload } from './core';
import { initFeatureFlags, trackFeatureFlagEvent } from './featureFlags';
import { iframeAnalytics, trackObjectStoreAction, ufoEvent } from './telemetry';
import { bridgeConfigDelegates, type BridgeConfigDelegates } from './bridge-config-delegates';
import { fetchProduct } from './fetchProduct';
import { fetchRemote } from './fetchRemote';
import { enableTheming } from './enableTheming';
import { on, emit } from './events';
import { onPublic, emitPublic } from './publicEvents';
import { subscribeRealtimeChannel, publishRealtimeChannel } from './realtime';
import { getUrl, navigate } from './navigation';
import { createHistory } from './history';
import { openRovo, isRovoEnabled } from './rovo';
import {
	permissionBridgeMethods,
	type PermissionBridgeMethods,
} from './permissions';

export const bridgeMethods: BridgeConfigDelegates &
	PermissionBridgeMethods & {
		createHistory: typeof createHistory;
		emit: typeof emit;
		emitPublic: typeof emitPublic;
		enableTheming: typeof enableTheming;
		fetchProduct: typeof fetchProduct;
		fetchRemote: typeof fetchRemote;
		getContext: typeof getContext;
		getFrameId: typeof getFrameId;
		getUrl: typeof getUrl;
		'iframe-analytics': typeof iframeAnalytics;
		initFeatureFlags: typeof initFeatureFlags;
		invoke: typeof invoke;
		isRovoEnabled: typeof isRovoEnabled;
		navigate: typeof navigate;
		on: typeof on;
		onPublic: typeof onPublic;
		openRovo: typeof openRovo;
		publishRealtimeChannel: typeof publishRealtimeChannel;
		reload: typeof reload;
		subscribeRealtimeChannel: typeof subscribeRealtimeChannel;
		trackFeatureFlagEvent: typeof trackFeatureFlagEvent;
		trackObjectStoreAction: typeof trackObjectStoreAction;
		'ufo-event': typeof ufoEvent;
	} = {
	...bridgeConfigDelegates,
	// Core methods
	getContext,
	invoke,
	getFrameId,
	reload,
	// Fetch methods
	fetchProduct,
	fetchRemote,
	// Theming methods
	enableTheming,
	// Event methods
	on,
	emit,
	// Public event methods
	onPublic,
	emitPublic,
	// Realtime methods
	subscribeRealtimeChannel,
	publishRealtimeChannel,
	// Navigation methods
	getUrl,
	navigate,
	// History methods
	createHistory,
	// Feature flag methods
	initFeatureFlags,
	trackFeatureFlagEvent,
	// Telemetry methods
	'iframe-analytics': iframeAnalytics,
	trackObjectStoreAction,
	'ufo-event': ufoEvent,
	// Rovo methods
	isRovoEnabled,
	openRovo,
	// Permission methods
	...permissionBridgeMethods,
};
